import React from "react"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import styled from "styled-components"
import { selectTagDescriptionsByName } from "../observations/slice"

const Tag = styled.span`
  display: inline-block;
  padding: 0.1em 0.25em;
  margin: 0.15rem 0.25rem;
  min-width: 3.5rem;
  text-align: center;
  border-radius: 0.25rem;
  background-color: ${(props) => props.color};
  color: black;
  font-size: 0.9rem;
  transition: all 0.3s ease-out;
  &:hover {
    opacity: 0.6;
  }
`
// The name of the tag e.g. stars.
const TagName = ({ tag = {} }) => {
  const tagsDescriptionsByName = useSelector(selectTagDescriptionsByName)
  return tag ? (
    <Tag
      key={tag.name}
      color={tagsDescriptionsByName[tag.name]?.colorCode || "#cbe8ba"}
    >
      {tag.name}
    </Tag>
  ) : (
    <span />
  )
}

TagName.propTypes = {
  tag: PropTypes.object, // the tag
}

export default TagName
